import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const CAR = {
  nickname: 'PRODUCTS.CAR.nickname',
  properties: [
    { name: 'vehicleDrivingLength', key: 'DRIVING_LENGTH', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.5', value: '5000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.8', value: '8000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.10', value: '10000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.12', value: '12000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.14', value: '14000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.16', value: '16000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.18', value: '18000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.20', value: '20000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.25', value: '25000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.30', value: '30000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.40', value: '40000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.99', value: '99000' },
        ]
      }
    },
    { name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern(/^\d+$/)
      ]]
    },
    { name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.0', value: '0' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.2', value: '2000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.3', value: '3000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.5', value: '5000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.7', value: '7000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.10', value: '10000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.15', value: '15000' },
        ]
      },
    },
    { name: 'vehicleBonus', key: 'BONUS', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.0', value: '0' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.10', value: '10' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.20', value: '20' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.30', value: '30' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.40', value: '40' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.50', value: '50' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.60', value: '60' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.70', value: '70' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_1', value: '75,1' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_2', value: '75,2' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_3', value: '75,3' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_4', value: '75,4' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_5', value: '75,5' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_6', value: '75,6' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.80', value: '80' }
        ]
      }
    },
    { name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ANSVAR', value: 'ANSVAR' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.DELKASKO', value: 'DELKASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.KASKO', value: 'KASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.SUPER', value: 'SUPER' },
        ]
      }
    },
    { name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required,
        Validators.pattern(/[a-zA-Z]{2}\d{5}/)
      ]]
    },

    { name: 'vehicleBonusYears', key: 'BONUS_YEARS', group: 'INSURANCE_INFO' },
    { name: 'nextVehicleBonus', key: 'NEXT_VEHICLE_BONUS', group: 'INSURANCE_INFO' },
    { name: 'vehicleYoungDriver', key: 'YOUNG_DRIVER', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'vehicleRentalCarCover', key: 'RENTAL_CAR_COVER', group: 'INSURANCE_INFO' },
    { name: 'tffIntendedStartDate', key: 'TFF_INTENDED_START_DATE', group: 'INSURANCE_INFO' },
    { name: 'vehicleDrivingLengthReadingKm', key: 'DRIVING_LENGTH_READING_KM', group: 'INSURANCE_INFO' },
    { name: 'vehicleDrivingLengthReadingDate', key: 'DRIVING_LENGTH_READING_DATE', group: 'INSURANCE_INFO' },
    { name: 'tffRegisteredOnOwnerFirstTime', key: 'TFF_REGISTERED_ON_OWNER_FIRST_TIME', group: 'INSURANCE_INFO' },
    { name: 'tffVehicleBrand', key: 'TFF_VEHICLE_BRAND', group: 'OBJECT_INFO' },
    { name: 'tffVehicleModel', key: 'TFF_VEHICLE_MODEL', group: 'OBJECT_INFO' },
    { name: 'vehicleRegistrationYear', key: 'REGISTRATION_YEAR', group: 'OBJECT_INFO'},
    { name: 'tffVehicleGroupCode', key: 'TFF_VEHICLE_GROUP_CODE', group: 'OBJECT_INFO' },
    { name: 'tffVehicleEnginePower', key: 'TFF_VEHICLE_ENGINE_POWER', group: 'OBJECT_INFO' }
  ],
  icon: 'car'
};
